export enum TechnicalSwitchDeviceTypes {
  switch = 'switch',
  router = 'router',
  firewall = 'firewall',
}
